export const WorkflowTemplateTypeConstants = {
  DEAL: "Deal",
  PROJECT: "Project",
};
